import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx';

// Import Tailwind (priorité la plus basse)
import './index.css';

// Import des styles par ordre de priorité
// 1. Variables globales et base
import './styles/globals.css';

// 2. Composants communs
import './styles/components/buttons.css';
import './styles/components/forms.css';
import './styles/components/tabs.css';
import './styles/components/navigation.css';
import './styles/components/admin.css';
import './styles/components/dynamic-select.css';

// 3. Thèmes (priorité la plus haute)
import './styles/themes/appsmith.css';
import './styles/themes/dark.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
